module.exports = __webpack_public_path__ + "img/body-1-lg.79fada30.png";